"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomEarlyWithdrawalPopoverModal = CustomEarlyWithdrawalPopoverModal;
exports.CustomRetirementContributionsPopoverModal = CustomRetirementContributionsPopoverModal;
exports.CustomTaxBracketPopoverModal = CustomTaxBracketPopoverModal;
exports.TaxRateChartPopoverModal = TaxRateChartPopoverModal;
var _react = _interopRequireDefault(require("react"));
var _reactBootstrap = require("react-bootstrap");
var _reactBlueprintLibrary = require("react-blueprint-library");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// This file is to hold all custom Popovers (e.g. popovers that contain some header/title, icon, table, etc.
// that is specific to the Traditional vs. Roth Contribution calculator and that which is not covered by the common info popover in the Wizard folder)

function TaxRateChartPopoverModal(_ref) {
  var {
    show,
    fieldName
  } = _ref;
  var title = "Tax Rate Chart";
  var text = "You can find your taxable income for the year on your tax return (Form 1040, Line 15) \n    and then compare this number to the 2023 IRS income tax tables shown here.";
  var largeModalTaxRate = /*#__PURE__*/_react.default.createElement("span", {
    className: "info-icon"
  }, /*#__PURE__*/_react.default.createElement("button", {
    id: "modal-large".concat(fieldName)
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal, {
    size: "lg",
    show: show
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Body, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col"
  }, /*#__PURE__*/_react.default.createElement("strong", null, " ", title, " ")), /*#__PURE__*/_react.default.createElement("div", {
    className: "col custom-popover-modal-close-icon"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "icon-sm icon-close"
  }))), /*#__PURE__*/_react.default.createElement("p", null, " ", text, " "), /*#__PURE__*/_react.default.createElement("div", {
    className: "container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "tax-rate-table"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.SimpleTable, {
    tableCaption: "Table displaying 2023 IRS income tax tables"
  }, /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.SimpleTable.HeaderCell, {
    id: "firstColHeader"
  }, "Tax Rate"), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.SimpleTable.HeaderCell, {
    id: "secondColHeader"
  }, "Single Filer"), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.SimpleTable.HeaderCell, {
    id: "thirdColHeader"
  }, "Married Filing Jointly"))), /*#__PURE__*/_react.default.createElement("tbody", null, /*#__PURE__*/_react.default.createElement("tr", {
    id: "taxChartRow1"
  }, /*#__PURE__*/_react.default.createElement("td", {
    id: "taxPercentRow1"
  }, "10%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "singleFilerBracketRow1"
  }, "$0 to $11,000"), /*#__PURE__*/_react.default.createElement("td", {
    id: "marriedJointBracketRow1"
  }, "$0 to $22,000")), /*#__PURE__*/_react.default.createElement("tr", {
    id: "taxChartRow2"
  }, /*#__PURE__*/_react.default.createElement("td", {
    id: "taxPercentRow2"
  }, "12%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "singleFilerBracketRow2"
  }, "$11,001 to $44,725"), /*#__PURE__*/_react.default.createElement("td", {
    id: "marriedJointBracketRow2"
  }, "$22,001 to $89,450")), /*#__PURE__*/_react.default.createElement("tr", {
    id: "taxChartRow3"
  }, /*#__PURE__*/_react.default.createElement("td", {
    id: "taxPercentRow3"
  }, "22%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "singleFilerBracketRow3"
  }, "$44,726 to $95,375"), /*#__PURE__*/_react.default.createElement("td", {
    id: "marriedJointBracketRow3"
  }, "$89,451 to $190,750")), /*#__PURE__*/_react.default.createElement("tr", {
    id: "taxChartRow4"
  }, /*#__PURE__*/_react.default.createElement("td", {
    id: "taxPercentRow4"
  }, "24%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "singleFilerBracketRow4"
  }, "$95,376 to $182,100"), /*#__PURE__*/_react.default.createElement("td", {
    id: "marriedJointBracketRow4"
  }, "$190,751 to $364,200")), /*#__PURE__*/_react.default.createElement("tr", {
    id: "taxChartRow2"
  }, /*#__PURE__*/_react.default.createElement("td", {
    id: "taxPercentRow2"
  }, "32%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "singleFilerBracketRow2"
  }, "$182,101 to $231,250"), /*#__PURE__*/_react.default.createElement("td", {
    id: "marriedJointBracketRow2"
  }, "$364,201 to $462,500")), /*#__PURE__*/_react.default.createElement("tr", {
    id: "taxChartRow3"
  }, /*#__PURE__*/_react.default.createElement("td", {
    id: "taxPercentRow3"
  }, "35%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "singleFilerBracketRow3"
  }, "$231,251 to $578,125"), /*#__PURE__*/_react.default.createElement("td", {
    id: "marriedJointBracketRow3"
  }, "$462,501 to $693,750")), /*#__PURE__*/_react.default.createElement("tr", {
    id: "taxChartRow4"
  }, /*#__PURE__*/_react.default.createElement("td", {
    id: "taxPercentRow4"
  }, "37%"), /*#__PURE__*/_react.default.createElement("td", {
    id: "singleFilerBracketRow4"
  }, "$578,126 or more"), /*#__PURE__*/_react.default.createElement("td", {
    id: "marriedJointBracketRow4"
  }, "$693,751 or more"))))))))));
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.OverlayTrigger, {
    trigger: "click",
    placement: "top",
    rootClose: true,
    overlay: largeModalTaxRate
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    variant: "none",
    "aria-label": 'taxRateChart popover',
    className: "btn-inline"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "icon-info"
  })));
}
function CustomEarlyWithdrawalPopoverModal(_ref2) {
  var {
    show,
    fieldName
  } = _ref2;
  var title = "Early withdrawal penalities may apply if you:";
  var bullet1 = "Withdraw from a Roth account within 5 years of your first contribution";
  var mediumModalWithdrawal = /*#__PURE__*/_react.default.createElement("button", {
    id: "modal-md ".concat(fieldName)
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal, {
    size: "md",
    show: show
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Body, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-9"
  }, /*#__PURE__*/_react.default.createElement("strong", null, " ", title, " ")), /*#__PURE__*/_react.default.createElement("div", {
    className: "col custom-popover-modal-close-icon"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "icon-sm icon-close"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "row align-items-center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-3"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "rothVsTrad-icon-marginLeft-inside-popover"
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "icon-xl icon-money-wings-black"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "col"
  }, /*#__PURE__*/_react.default.createElement("li", null, bullet1), /*#__PURE__*/_react.default.createElement("li", null, "Withdraw from a Traditional or Roth account before you are 59\xBD"))))));
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.OverlayTrigger, {
    trigger: "click",
    placement: "top",
    rootClose: true,
    overlay: mediumModalWithdrawal
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    variant: "none",
    "aria-label": 'earlyWithdrawal popover',
    className: "btn-inline"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "icon-info"
  })));
}
function CustomTaxBracketPopoverModal(_ref3) {
  var {
    show,
    fieldName
  } = _ref3;
  var title = "Tax Bracket";
  var higherBullet1 = "You believe your income may increase";
  var higherBullet2 = "You think you'll still be working when you begin making withdrawals";
  var lowerBullet1 = "You believe your income may decrease";
  var lowerBullet2 = "You think you may leave the workforce and plan to rely solely on retirement savings and other sources of income";
  var mediumModalTaxBracket = /*#__PURE__*/_react.default.createElement("button", {
    id: "modal-md ".concat(fieldName)
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal, {
    size: "md",
    show: show
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Body, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-9"
  }, /*#__PURE__*/_react.default.createElement("strong", null, " ", title, " ")), /*#__PURE__*/_react.default.createElement("div", {
    className: "col custom-popover-modal-close-icon"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "icon-sm icon-close"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "row align-items-center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-3"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "rothVsTrad-icon-marginLeft-inside-popover"
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "icon-xl icon-arrow-stroke-spin-up-black"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "col"
  }, "Select ", /*#__PURE__*/_react.default.createElement("strong", null, "higher"), " if:", /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, higherBullet1), /*#__PURE__*/_react.default.createElement("li", null, higherBullet2)))), /*#__PURE__*/_react.default.createElement("p", null), /*#__PURE__*/_react.default.createElement("div", {
    className: "row align-items-center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-3"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "rothVsTrad-icon-marginLeft-inside-popover"
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "icon-xl icon-arrow-stroke-spin-down-black"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "col"
  }, "Select ", /*#__PURE__*/_react.default.createElement("strong", null, "lower"), " if:", /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, lowerBullet1), /*#__PURE__*/_react.default.createElement("li", null, lowerBullet2)))))));
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.OverlayTrigger, {
    trigger: "click",
    placement: "top",
    rootClose: true,
    overlay: mediumModalTaxBracket
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    variant: "none",
    "aria-label": 'taxBracket popover',
    className: "btn-inline"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "icon-info"
  })));
}
function CustomRetirementContributionsPopoverModal(_ref4) {
  var {
    show,
    fieldName
  } = _ref4;
  var title = "Retirement Contributions";
  var nowBullet = "You prefer that your earnings have the opportunity to grow tax-free";
  var laterBullet = "You prefer to receive a tax benefit today and defer paying taxes until you make withdrawals later on";
  var mediumModalRetirementContributions = /*#__PURE__*/_react.default.createElement("button", {
    id: "modal-md ".concat(fieldName)
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal, {
    size: "md",
    show: show
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Body, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-9"
  }, /*#__PURE__*/_react.default.createElement("strong", null, " ", title, " ")), /*#__PURE__*/_react.default.createElement("div", {
    className: "col custom-popover-modal-close-icon"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "icon-sm icon-close"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "row align-items-center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-3"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "rothVsTrad-icon-marginLeft-inside-popover"
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "icon-xl icon-money-now-black"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "col"
  }, "Select ", /*#__PURE__*/_react.default.createElement("strong", null, "now"), " if:", /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, nowBullet)))), /*#__PURE__*/_react.default.createElement("p", null), /*#__PURE__*/_react.default.createElement("div", {
    className: "row align-items-center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-3"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "rothVsTrad-icon-marginLeft-inside-popover"
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "icon-xl icon-money-later-black"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "col"
  }, "Select ", /*#__PURE__*/_react.default.createElement("strong", null, "later"), " if:", /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, laterBullet)))))));
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.OverlayTrigger, {
    trigger: "click",
    placement: "top",
    rootClose: true,
    overlay: mediumModalRetirementContributions
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    variant: "none",
    "aria-label": 'retirementContributions popover',
    className: "btn-inline"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "icon-info"
  })));
}